module.exports = __webpack_public_path__ + "img/ic_down.1088d56.svg";